/* Models */
import { RowAd } from '../models';

/* ActionTypes */
import { CAROUSEL_ENTITY_ACTION_TYPES } from '../carousels/actionTypes';

/* Utils */
import { generateEntityReducer } from '../utils/generators/reducerGenerators';

const rowAdsReducer = generateEntityReducer(CAROUSEL_ENTITY_ACTION_TYPES, RowAd);

export default rowAdsReducer;
